import { Typography, TypographyTextProps } from '@arco-design/web-react';
import React from 'react';

const { Text } = Typography;

type IProps = {
  value: string;
} & TypographyTextProps;

export function TextEllipsis({
  value,
  copyable = false,
  ellipsis = { showTooltip: true },
}: IProps) {
  if (!value) {
    return null;
  }
  return (
    <Text style={{ marginBottom: 0 }} copyable={copyable} ellipsis={ellipsis}>
      {value}
    </Text>
  );
}
